import type { Algorithm, ClientType, GrantType } from './types'

type ClientTypePolicy = {
  defaultGrant: GrantType
  allowedGrants: ReadonlyArray<{ value: GrantType; label: string }>
  allowedAlgorithms: ReadonlyArray<{ value: Algorithm; label: string }>
  defaultPkceRequired: boolean
  pkceLocked: boolean
  defaultAllowClientCredentials: boolean
  allowClientCredentialsLocked: boolean
  redirectUrisRequired: boolean
}

export const CLIENT_TYPE_POLICY: Record<ClientType, ClientTypePolicy> = {
  public: {
    defaultGrant: 'authorization-code',
    allowedGrants: [
      { value: 'authorization-code', label: 'Authorization code' },
      { value: 'openid-hybrid', label: 'OpenID hybrid' }
    ],
    allowedAlgorithms: [
      { value: '', label: 'None' },
      { value: 'RS256', label: 'RS256' }
    ],
    defaultPkceRequired: true,
    pkceLocked: true,
    defaultAllowClientCredentials: false,
    allowClientCredentialsLocked: true,
    redirectUrisRequired: true
  },
  confidential: {
    defaultGrant: 'client-credentials',
    allowedGrants: [
      { value: 'authorization-code', label: 'Authorization code' },
      { value: 'client-credentials', label: 'Client credentials' },
      { value: 'implicit', label: 'Implicit' },
      { value: 'openid-hybrid', label: 'OpenID hybrid' },
      { value: 'password', label: 'Password' }
    ],
    allowedAlgorithms: [
      { value: '', label: 'None' },
      { value: 'RS256', label: 'RS256' },
      { value: 'HS256', label: 'HS256' }
    ],
    defaultPkceRequired: true,
    pkceLocked: false,
    defaultAllowClientCredentials: true,
    allowClientCredentialsLocked: false,
    redirectUrisRequired: false
  }
}

export const REDIRECT_URI_PLACEHOLDER = `https://app.example.com/auth/callback
https://app.example.com/silent-renew`

export const POST_LOGOUT_URI_PLACEHOLDER = `https://app.example.com/logged-out`

export const ALLOWED_ORIGINS_PLACEHOLDER = `https://app.example.com`
